module.exports = __webpack_public_path__ + "img/multi_image05.0e1d44af.png";